import { IconInfoRegular, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

export interface OrderQuantityProps {
  text: string;
  display_recent_30days_note?: boolean;
}

export const OrderQuantity: React.FC<OrderQuantityProps> = ({ display_recent_30days_note, text }) => {
  return (
    <OrderQuantityWrapper>
      <IconInfoRegular width={18} height={18} color='textSecondary' style={{ marginRight: 3, flexShrink: 0 }} />
      <TextWrapper>
        <Text variant='Body_13_Regular' color='textSecondary' style={{ wordBreak: 'keep-all', paddingRight: '2px' }}>
          {text}
        </Text>
        {display_recent_30days_note && <OrderQuantityNote>(최근 30일 기준)</OrderQuantityNote>}
      </TextWrapper>
    </OrderQuantityWrapper>
  );
};

const OrderQuantityWrapper = styled.div`
  display: flex;
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const OrderQuantityNote = styled.small`
  font-size: 12px;
  color: ${vars.color.textTertiary};
`;
